import styled, { css } from 'styled-components'
import { maxXs, minXs } from '../../styles/breakPoints'

interface ContainerProps {
  isNavOpen: boolean
  isFixed: boolean
}
export const Container = styled.div<ContainerProps>`
  @media (${maxXs}) {
    hr {
      height: 0;
      opacity: 0.2;
      border: solid 0.5px #222222;
    }
  }
  @media (${minXs}) {
    hr {
      display: none;
    }
  }

  button {
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
  }

  ${(props) =>
    props.isNavOpen &&
    !props.isFixed &&
    css`
      position: fixed;
      background: #222222;
      height: 100%;
      z-index: 1;

      width: 70%;
      margin-left: 30%;
    `}

  ${(props) =>
    props.isFixed &&
    css`
      margin-top: -100vh;
      z-index: 1;
    `}

  ${(props) =>
    !props.isNavOpen &&
    props.isFixed &&
    css`
      margin-top: 0;
    `}

  ${(props) =>
    props.isNavOpen &&
    props.isFixed &&
    css`
      hr {
        display: none;
      }
    `}
`

interface HeaderProps {
  isNavOpen: boolean
}
export const Header = styled.header<HeaderProps>`
  display: flex;
  /* width: 100vw; */
  padding: 45px;
  justify-content: space-between;
  align-items: center;

  div {
    display: flex;
    align-items: center;
  }

  a {
    text-decoration: none;
  }

  img {
    width: 78px;
    height: 40px;
    object-fit: contain;
  }

  @media (${maxXs}) {
    padding: 20px;
    img {
      width: 59px;
      ${(props) =>
        props.isNavOpen &&
        css`
          display: none;
        `}
    }
  }
  .fa {
    @media (${minXs}) {
      display: none;
    }
  }
  .fa-bars {
    ${(props) =>
      props.isNavOpen &&
      css`
        display: none;
      `}
  }
  .fa-times {
    color: white;
    ${(props) =>
      props.isNavOpen &&
      css`
        display: flex;
        justify-content: flex-end;
      `}
  }

  ${(props) =>
    props.isNavOpen &&
    css`
      height: 100vh;
      display: flex;
      flex-direction: column;
      justify-content: start;
      align-items: baseline;

      @media (${maxXs}) {
        padding: 0px;
        padding-top: 20px;
      }
    `}
`

interface NavProps {
  isOpen: boolean
}
export const Nav = styled.nav<NavProps>`
  font-size: 22px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.23;
  letter-spacing: normal;
  text-align: center;
  color: #222222;

  @media (${maxXs}) {
    display: ${({ isOpen }: NavProps) => (isOpen ? 'inherit' : 'none')};
  }

  ul {
    display: flex;
    list-style: none;

    li {
      margin-left: 30px;

      font-size: 16px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.25;
      letter-spacing: normal;
      text-align: center;

      a {
        text-decoration: none;
        color: #000000;
      }
    }

    ${(props) =>
      props.isOpen &&
      css`
        flex-direction: column;

        margin-left: 0px;
        li {
          text-align: left;
          margin-top: 20px;

          a,
          button {
            color: white;
          }
        }
      `}
  }

  .fa-times {
    font-size: 1.5em;
    justify-content: flex-end;
    padding-right: 25px;
    padding-top: 5px;
  }

  ${(props) =>
    props.isOpen &&
    css`
      flex-direction: column;
      width: 100%;
    `}
`
